import { AkiosMeta } from "/src/akios/akios";
import { AxiosResponse, AxiosError } from "axios";
import { message } from "antd";
import debounce from "lodash/debounce";

function handleError(error: AxiosError, setState: any) {
  if (!error) return;
  const config: AkiosMeta = error.config as any;
  const response: AxiosResponse = error.response as any;

  // disable error handling
  if (config.globalErrorHandler === false) {
    return;
  }

  // automatically show error messages
  console.log(config);
  console.log(config.errorMessage);
  if (config.errorMessage) {
    if (config.errorMessage === true) {
      const serverErrorMessage = response?.data?.message;
      if (serverErrorMessage) {
        message.error(serverErrorMessage);
      }
      return;
    }
    if (config.errorMessage.length) {
      message.error(config.errorMessage);
      return;
    }
  }

  // handle error according to response
  if (response) {
    if ([409].indexOf(response.status) > -1) {
      message.error(response.data?.message ?? "Conflict Operation, please try it later");
      return;
    }
    if ([500, 501, 502, 503].indexOf(response.status) > -1) {
      setState(error);
      return;
    }

    setState(error);
  } else {
    setState(error);
  }
}

export const debouncedHandleError = debounce((error: AxiosError, setState: any) => {
  handleError(error, setState);
}, 200);
